import React from 'react';

const LeaseCustomField = ({ customField, index, basePath }) => {
  const { custom_field_type: fieldType, value } = customField;
  const isRequired = ['always_required', 'required_for_tenant'].includes(
    fieldType.requirement_option
  );
  const fieldName = `${basePath}[${index}][value]`;
  const typeIdName = `${basePath}[${index}][custom_field_type_id]`;
  const fieldId = fieldName.replace(/\[/g, '_').replace(/\]/g, '');
  const typeId = typeIdName.replace(/\[/g, '_').replace(/\]/g, '');

  switch (fieldType.field_type) {
    case 'select':
      return (
        <div
          key={index}
          className={`pm-flex pm-flex-col ${isRequired ? 'required_field' : ''}`}
        >
          <div className="pm-select">
            <label htmlFor={fieldId} className="pm-select2-label">
              {fieldType.name}
            </label>
            <input
              type="hidden"
              name={typeIdName}
              id={typeId}
              value={fieldType.id}
            />
            <select
              name={fieldName}
              id={fieldId}
              className="pm-default-select2-menu mdc-select pm-select-small"
              defaultValue={value}
            >
              {fieldType.options?.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
      );
    case 'text':
    case 'currency':
    case 'number':
    case 'time':
      return (
        <div
          key={index}
          className={`pm-flex pm-flex-col ${isRequired ? 'required_field' : ''}`}
        >
          <div className="mdc-form-field mdc-form-field--align-end">
            <div
              className="mdc-text-field pm-margin-none"
              data-mdc-auto-init="MDCTextField"
            >
              <label htmlFor={fieldId} className="mdc-floating-label">
                {fieldType.name}
              </label>
              <input
                type="hidden"
                name={typeIdName}
                id={typeId}
                value={fieldType.id}
              />
              <input
                type={fieldType.field_type === 'text' ? 'text' : 'number'}
                name={fieldName}
                id={fieldId}
                className="mdc-text-field__input custom_field"
                defaultValue={value}
              />
            </div>
          </div>
        </div>
      );
    case 'date':
    case 'date / time':
      return (
        <div
          key={index}
          className={`pm-flex pm-flex-col ${isRequired ? 'required_field' : ''}`}
        >
          <div className="mdc-form-field mdc-form-field--align-end">
            <div
              className="mdc-text-field pm-margin-none"
              data-mdc-auto-init="MDCTextField"
            >
              <label htmlFor={fieldId} className="mdc-floating-label">
                {fieldType.name}
              </label>
              <input
                type="hidden"
                name={typeIdName}
                id={typeId}
                value={fieldType.id}
              />
              <input
                type="text"
                name={fieldName}
                id={fieldId}
                className={`mdc-text-field__input pm-${fieldType.field_type === 'date' ? 'date' : 'datetime'}picker-field`}
                defaultValue={value}
              />
            </div>
          </div>
        </div>
      );
    case 'checkbox':
      return (
        <div
          key={index}
          className={`pm-flex pm-flex-col ${isRequired ? 'required_field' : ''}`}
        >
          <div className="mdc-form-field mdc-form-field--align-end">
            <label htmlFor={fieldId}>{fieldType.name}</label>
            <input
              type="hidden"
              name={typeIdName}
              id={typeId}
              value={fieldType.id}
            />
            <div
              id="mdc-js-checkbox"
              className="mdc-checkbox"
              data-mdc-auto-init="MDCCheckbox"
            >
              <input
                type="checkbox"
                name={fieldName}
                id={fieldId}
                className="mdc-checkbox__native-control custom_field"
                value="true"
                defaultChecked={value === 'true' || value === true}
              />
              <div className="mdc-checkbox__background">
                <svg className="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    className="mdc-checkbox__checkmark-path"
                    fill="none"
                    stroke="white"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div className="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return (
        <div
          key={index}
          className={`pm-flex pm-flex-col ${isRequired ? 'required_field' : ''}`}
        >
          <div className="mdc-form-field mdc-form-field--align-end">
            <label htmlFor={fieldId} className="mdc-floating-label">
              {fieldType.name}
            </label>
            <input
              type="hidden"
              name={typeIdName}
              id={typeId}
              value={fieldType.id}
            />
            <input
              type="text"
              name={fieldName}
              id={fieldId}
              className="mdc-text-field__input custom_field"
              defaultValue={value}
            />
          </div>
        </div>
      );
  }
};

export default LeaseCustomField;
